// extracted by mini-css-extract-plugin
export default {"cls1":"VeloErrorCard-Error_cls1__XQHdq","cls2":"VeloErrorCard-Error_cls2__HmgGv VeloErrorCard-Error_cls1__XQHdq"};